export default "__VITE_ASSET__CAQzwNtj__"